module.exports = __webpack_public_path__ + "img/upper pocket flap width.f9f274bc.png";